export type SyncSettingsType = {
  empty: string;
  sinceLastSync: string;
  allTransactions: string;
};

export enum TransactionType {
  capitalCalls = "capitalCalls",
  distributions = "distributions",
  capitalActivity = "capitalActivity",
  netIncome = "netIncome",
}

export type InitialValues = {
  firstIntegrationThroughDate: Date | null;
  updateDateRange: string;
  customDate: Date | null;
  syncSettings: string;
  [TransactionType.capitalCalls]: boolean;
  [TransactionType.distributions]: boolean;
  [TransactionType.capitalActivity]: boolean;
  [TransactionType.netIncome]: boolean;
  integrationStart: Date | null;
  useInceptionDate: boolean;
  integrationThrough: Date | null;
};
